module.exports = __webpack_public_path__ + "img/miryoku_c1.96d18f38.png";